import './ExpandCarat.scss';
import { CaretRightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';

export interface ExpandCaratProps {
	className?: string;
	disabled?: boolean;
	expanded: boolean;
	onClick: () => void;
}

export const ExpandCarat: React.FC<ExpandCaratProps> = ({ className, expanded, onClick }) => {
	const buttonClassNames = classNames('expand-carat', className);

	return (
		<div
			className={ buttonClassNames }
			onClick={ onClick }>
			<CaretRightOutlined rotate={ expanded ? 90 : 0 } />
		</div>
	);
};
